$(window).on("load", function () {
  $(".twentytwenty-container").twentytwenty();
});
$(document).ready(function () {

  $('.faq-item .faq-title').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).next('.faq-content').slideToggle();
  });
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 2,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 2
      },
    },
  });
  // footer mobile
  $('.footer-block .footer-block__heading').click(function (e) {
    e.preventDefault();
    $(this).parent('.footer-block').toggleClass('active');
  })
  $('.product-rte .info').click(function (e) {
    e.preventDefault();
    $(".infopop").show(300);
  })

  $('.overfloo .close2').click(function (e) {
    e.preventDefault();
    $(".infopop").hide(300);
  })

  $('.scrolltodiv').click(function (e) {
    e.preventDefault();
    check = $(this).data('index');
    $('html, body').animate({
      scrollTop: $(".toc-item[data-check=" + check + "]").offset().top - 20
    }, 1000)
  })

  $('.button_popup').click(function () {
    $(".form_popup").addClass("active");
  })
  $('.button_close_popup').click(function () {
    $(".form_popup").removeClass("active");
  })
  // click outsite close cart slideout 
  $(document).on('click', function(e) {
      var container = $('.button_popup');
      var container1 = $('.button_close_popup');
      var container2 = $('.form_popup .block_popup');
      if (!container1.is(e.target) && container1.has(e.target).length === 0 && !container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0) {
        $('.form_popup').removeClass('active');
      }
  });

  $('.overfloo .close2').click(function (e) {
    e.preventDefault();
    $(".infopop").hide(300);
  })

  function countdownInit(el) {
    var countdowns = $('.countdown');
    if (countdowns.length > 0) {
      countdowns.each(function () {
        initCountdown($(this));
      });
    }
  }


  function initCountdown(countdown) {
    var year = parseInt(countdown.data('year'));
    var month = parseInt(countdown.data('month'));
    var day = parseInt(countdown.data('day'));
    var hours = parseInt(countdown.data('hours'));
    var newDate = new Date(year, month, day, hours);
    //console.log(newDate);
    var textDay = countdown.data('text-day');
    var textHour = countdown.data('text-hour');
    var textMin = countdown.data('text-min');
    var textSec = countdown.data('text-sec');
    countdown.countdown(newDate, function (event) {
      $(this).html(
        event.strftime('<div class="column_box"><div class="countdown_column"><span class="number">%D</span><span class="text">' + textDay + '</span></div><span class="count-dot">:</span></div><div class="column_box"><div class="countdown_column"><span class="number">%H</span><span class="text">' + textHour + '</span></div><span class="count-dot">:</span></div><div class="column_box"><div class="countdown_column"><span class="number">%M</span><span class="text">' + textMin + '</span></div><span class="count-dot">:</span></div><div class="column_box"><div class="countdown_column"><span class="number">%S</span><span class="text">' + textSec + '</span></div></div>')
      );
    });
  }
  countdownInit();
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      countdownInit();
    })
  }
//   window.form = "";
//   $('#ContactFooter button').click(function (evt) {
//     evt.preventDefault();
//     var form = document.forms['ContactFooter'];
//     var formData = new FormData(form);
//     post("/contact#ContactFooter",formData);
// });

// function post(scriptURL, formData) {
  
//     fetch(scriptURL, { method: 'POST', body: formData, headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': 'text/html, */*; q=0.01', 'X-Requested-With': 'XMLHttpRequest'}})
//         .then(response =>
//             console.log(response)
//         )
//         .catch(error => console.log(error))
// }
});

// Sketchus floating UI: cookie priority, five quiet seconds, manual opening only.
(function () {
  if (window.sketchusFloatingUiBound) return;
  window.sketchusFloatingUiBound = true;
  var delayMs = 5000;
  var privacyResolved = false;
  var releaseTimer = null;
  var clearPrivacyChecks = 0;
  var tidioBound = false;

  function givePriority() {
    document.dispatchEvent(new CustomEvent('sketchus:overlay-priority'));
  }

  function setChatOpen(open) {
    document.body.classList.toggle('sketchus-chat-open', open);
    document.body.classList.toggle('tidio-open', open);
    if (open) givePriority();
    // Never re-open the voucher when chat closes. Its current step is retained.
  }

  function bindTidio() {
    var api = window.tidioChatApi;
    if (!api || typeof api.on !== 'function' || tidioBound) return;
    tidioBound = true;
    api.on('beforeOpen', function () { setChatOpen(true); });
    api.on('open', function () { setChatOpen(true); });
    api.on('close', function () { setChatOpen(false); });
  }

  function cookieDialogVisible() {
    var selectors = [
      '#shopify-pc__banner',
      '#shopify-pc__prefs',
      '.shopify-pc__banner__dialog',
      '.shopify-pc__prefs__dialog',
      '[id^="shopify-pc__banner"]',
      '[id^="shopify-pc__prefs"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var element = document.querySelector(selectors[i]);
      if (!element) continue;
      var css = window.getComputedStyle(element);
      if (css.display !== 'none' && css.visibility !== 'hidden' && css.opacity !== '0') return true;
    }
    return false;
  }

  function privacyBannerPending() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.shouldShowBanner === 'function') {
        return window.Shopify.customerPrivacy.shouldShowBanner();
      }
    } catch (error) {}

    if (cookieDialogVisible()) return true;
    return null;
  }


  function resolvePrivacyState() {
    var pending = privacyBannerPending();
    if (cookieDialogVisible() || pending === true) {
      clearPrivacyChecks = 0;
      privacyResolved = false;
      window.clearTimeout(releaseTimer);
      releaseTimer = null;
      document.documentElement.classList.remove('sketchus-floating-ready');
      document.body.classList.add('sketchus-overlay-gate');
      givePriority();
      return;
    }
    if (privacyResolved) return;
    // Briefly allow an asynchronously inserted cookie banner to appear.
    if (pending === null && ++clearPrivacyChecks < 2) return;
    privacyResolved = true;
    releaseTimer = window.setTimeout(function () {
      releaseTimer = null;
      if (!privacyResolved || cookieDialogVisible() || privacyBannerPending() === true) {
        privacyResolved = false;
        resolvePrivacyState();
        return;
      }
      document.body.classList.remove('sketchus-overlay-gate');
      document.documentElement.classList.add('sketchus-floating-ready');
    }, delayMs);
  }

  function start() {
    document.body.classList.add('sketchus-overlay-gate');
    resolvePrivacyState();
    window.setInterval(resolvePrivacyState, 500);
    bindTidio();
  }

  document.addEventListener('tidioChat-ready', bindTidio);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
